module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/68c532d1295ba8ee1af5e2ce8148422d.png";